module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "slide14.408f0d37.jpg" + "?" + Date.now();